import React from 'react';
import { Bubble } from 'reactApp/ui/Bubble/Bubble';
import { Button } from 'reactApp/ui/Button/Button';
import { tooltipPlacements } from 'reactApp/ui/Tooltip/Tooltip.constants';

import styles from './WebPushBubble.css';

interface IProps {
    onClose(): void;
    onPostpone(): void;
    onAction(): void;
    isBlocked?: boolean;
}

export const WebPushBubble = ({ onAction, onClose, onPostpone, isBlocked }: IProps) => {
    const content = (
        <>
            <div className={styles.text}>
                {isBlocked
                    ? 'В настройках браузера заблокированы уведомления'
                    : 'Включите уведомления об акциях и новых функциях Облака в браузере'}
            </div>
            {isBlocked ? (
                <Button primary middle theme="octavius" onClick={onAction}>
                    Как включить уведомления
                </Button>
            ) : (
                <div className={styles.buttons}>
                    <Button primary middle theme="octavius" onClick={onAction}>
                        Включить
                    </Button>
                    <Button middle theme="octavius" onClick={onPostpone}>
                        Не сейчас
                    </Button>
                </div>
            )}
        </>
    );

    return (
        <Bubble
            noArrow
            placement={tooltipPlacements.BOTTOM_LEFT}
            text={content}
            onClose={onClose}
            closeOnOutsideClick={false}
            smartPlacement={false}
            fixed
        >
            <div className={styles.target} />
        </Bubble>
    );
};
